/* eslint-disable no-console,no-unused-vars */
import React from 'react';
import {AsyncButton, Dialog} from '@nike/ruxac';
import {setNoCheckBoxSelectedFilter} from '../Actions/loading';
import {createAllPDF,createSelectedPDF,createExcelFile} from '../APIs/dataHelper';
import {errorCodeLibrary} from '../APIs/errorCodes';
import {connect} from "react-redux";
import {setErrorState} from "../Actions/errorHandler";
export class Buttons extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            dialogOpen       : false,
            isCreatingExcel  : false,
            isCreatingSelPDF : false,
            isCreatingAllPDF : false,
            pdfDialogOpen    : false
        };

        this.onCreateExcel         = this.onCreateExcel.bind(this);
        this.onCreateSelPDF         = this.onCreateSelPDF.bind(this);
        this.onCreateAllPDF         = this.onCreateAllPDF.bind(this);
    }
    async onCreateExcel() {
        this.setState({isCreatingExcel : true});
        await createExcelFile(this.props.userInfo.userName, this.props.userInfo.searchTimestamp, 5)
            .then(() => {
                this.setState({isCreatingExcel : false});
            })
            .catch((err) => {
                this.setState({isCreatingExcel : false});
                this.props.setErrorState(err.response.status, errorCodeLibrary.createExcelErrorCodes[err.response.status] ? errorCodeLibrary.createExcelErrorCodes[err.response.status] : errorCodeLibrary.createExcelErrorCodes.default);
            });
    }

    async onCreateSelPDF() {
        this.setState({isCreatingSelPDF : true});
        await createSelectedPDF(this.props.userInfo.userName, this.props.userInfo.searchTimestamp)
            .then(() => {
                this.setState({isCreatingSelPDF : false});
            })
            .catch((err) => {
                this.setState({isCreatingSelPDF : false});
                this.props.setErrorState(err.response.status, errorCodeLibrary.createSelPDFErrorCodes[err.response.status] ? errorCodeLibrary.createSelPDFErrorCodes[err.response.status] : errorCodeLibrary.createSelPDFErrorCodes.default);
            });
    }

    async onCreateAllPDF() {
        this.setState({isCreatingAllPDF : true});
        this.setState({dialogOpen : false});
        await createAllPDF(this.props.userInfo.userName, this.props.userInfo.searchTimestamp)
            .then(() => {
                this.setState({isCreatingAllPDF : false});
            })
            .catch((err) => {
                this.setState({isCreatingAllPDF : false});
                this.props.setErrorState(err.response.status, errorCodeLibrary.createAllPDFErrorCodes[err.response.status] ? errorCodeLibrary.createAllPDFErrorCodes[err.response.status] : errorCodeLibrary.createAllPDFErrorCodes.default);
            });
    }

    render(){
        const r = this.props.rowCount > 1 ? `records` : `record`;
        const showDialog = () => this.setState({dialogOpen : true});
        const closeDialog = () => this.setState({ dialogOpen : false });

        return (
            <div className={`row`}>
                <div className={`col-xs-2`}>
                    <AsyncButton //add functionality to make sure at least one is checked
                        name='createExcelBtn'
                        disabled={!this.props.dataCached}
                        loading={this.state.isCreatingExcel}
                        onClick={this.onCreateExcel}
                    >
                        {this.props.dataCached ? "Create Excel File" : "Data Caching.."}
                    </AsyncButton>
                </div>
                <div className={`col-xs-2`}>
                    <AsyncButton //add functionality to make sure at least one is checked
                        name='createSelPDFBtn'
                        disabled={!this.props.canGeneratePDF || !this.props.dataCached }
                        loading={this.state.isCreatingSelPDF}
                        onClick={this.onCreateSelPDF}
                    >
                        {this.props.dataCached ? "Create Selected PDFs" : "Data Caching.."}

                    </AsyncButton>
                </div>
                <div className={` col-xs-2`}>
                    <AsyncButton
                        name='createAllPDFBtn'
                        disabled={!this.props.dataCached}
                        loading={this.state.isCreatingAllPDF}
                        onClick={ () => {
                            showDialog();
                        }
                        }
                    >
                        {this.props.dataCached ? "Create All PDFs" : "Data Caching.."}

                    </AsyncButton>
                </div>
                <Dialog
                    className={`dialog-confirm`}
                    content={`Please confirm that you want to create PDFs for ${this.props.rowCount} ${r}`  }
                    cancelText="Cancel"
                    confirmText="Confirm"
                    onCancel={() => {
                        this.setState({ dialogOpen : false });
                    }}
                    onConfirm={this.onCreateAllPDF}
                    onOverlayClick={() => {
                        this.setState({ dialogOpen : false });
                    }}
                    open={this.state.dialogOpen}
                    title="Confirm Create All PDFs"
                />
                {/*<SuccessNotification*/}
                {/*omitCloseIcon*/}
                {/*handleClose={this.onCreateExcel}*/}
                {/*messages={[{*/}
                {/*title : 'Excel File emailed',*/}
                {/*text  : 'You will receive you files in few minutes'*/}
                {/*}]}*/}
                {/*show={this.state.isCreatingExcel}*/}
                {/*/>*/}
                {/*<SuccessNotification*/}
                {/*omitCloseIcon*/}
                {/*handleClose={this.onCreateSelPDF}*/}
                {/*messages={[{*/}
                {/*title : 'Selected PDF Files emailed',*/}
                {/*text  : 'You will receive you files in few minutes'*/}
                {/*}]}*/}
                {/*show={this.state.isCreatingSelPDF}*/}
                {/*/>*/}
                {/*<SuccessNotification*/}
                {/*omitCloseIcon*/}
                {/*handleClose={this.onCreateAllPDF}*/}
                {/*messages={[{*/}
                {/*title : 'All PDFs Files emailed',*/}
                {/*text  : 'You will receive you files in few minutes'*/}
                {/*}]}*/}
                {/*show={this.state.isCreatingAllPDF}*/}
                {/*/>*/}
            </div>

        );
    }
}
const mapStateToProps = (state) => {
    return {
        filters          : state.filters,
        loadingIndicator : state.loadingIndicator,
        userInfo         : state.userInfo
    };
};
const mapDispatchToProps = {
    setNoCheckBoxSelectedFilter,
    createExcelFile,
    createAllPDF,
    createSelectedPDF,
    setErrorState

};
export default connect( mapStateToProps,mapDispatchToProps)(Buttons);




// WEBPACK FOOTER //
// ./src/Components/Buttons.js